export const removeSlots = function (featureDisplayAdsFlag) {
  if (featureDisplayAdsFlag) {
    const { googletag } = window;
    googletag.cmd.push(function () {
      googletag.destroySlots();
    });
  }
};

export const removeSingleSlot = function (id, featureDisplayAdsFlag) {
  if (featureDisplayAdsFlag) {
    const { googletag } = window;
    googletag.cmd.push(function () {
      googletag.destroySlots([id]);
    });
  }
};

export const displayAds = function (id, featureDisplayAdsFlag) {
  if (featureDisplayAdsFlag) {
    const { googletag } = window;
    googletag.cmd.push(function () {
      googletag.display(id);
    });
  }
};

export const refreshAds = function (featureDisplayAdsFlag) {
  if (featureDisplayAdsFlag) {
    const { googletag } = window;
    googletag.cmd.push(function () {
      googletag.pubads().refresh();
    });
  }
};

export const defineAdSlot = function (
  id,
  path,
  sizeMap,
  featureDisplayAdsFlag
) {
  if (featureDisplayAdsFlag) {
    const { googletag, getAllAdSizes } = window;
    googletag.cmd.push(function () {
      googletag
        .defineSlot(path, getAllAdSizes(sizeMap), id)
        .defineSizeMapping(sizeMap)
        .addService(googletag.pubads());
      googletag.display(id);
    });
  }
};
